<template>
  <div class="auth step-box">
    <form :action="authUrl" class="auth-form" method="post">
      <button @click.prevent="skip()" class="pz-close-btn-login"></button>

      <div class="auth-form__header">Авторизация</div>
      <div class="input-wrapper login-method">
        <label class="signup-radio signup-phone">
          <input
            type="radio"
            id="rbPhone"
            name="authByPhone"
            :value="AUTH_METHOD_PHONE"
            v-model="authMethod"
            v-on:change="onAuthMethodChange(AUTH_METHOD_PHONE, $event)"
            v-on:keydown.enter.prevent="submitAuth"
          />
          <label for="rbPhone">Номер телефона</label>
        </label>
        <label class="signup-radio signup-email">
          <input
            type="radio"
            id="rbLogin"
            name="authByEmail"
            :value="AUTH_METHOD_EMAIL"
            v-model="authMethod"
            v-on:change="onAuthMethodChange(AUTH_METHOD_EMAIL, $event)"
            v-on:keydown.enter.prevent="submitAuth"
          />
          <label for="rbLogin">Логин / e-mail</label>
        </label>
      </div>

      <div
        class="input-wrapper"
        v-if="this.authMethod == this.AUTH_METHOD_PHONE"
      >
        <input
          :class="{ hasError: this.loginError }"
          :value="login"
          @input="updateLogin"
          name="AuthForm[phone]"
          placeholder="Телефон в формате +7 (123) 456-78-90"
          type="text"
          v-mask="
            setting.currency === '₽'
              ? '+7 (###) ###-##-##'
              : '+375 (##) ###-##-##'
          "
          v-on:keydown.enter.prevent="submitAuth"
        />
        <div v-if="this.loginError">
          <p class="input-error" v-html="loginError"></p>
        </div>
      </div>
      <div class="input-wrapper" v-if="authMethod == AUTH_METHOD_EMAIL">
        <input
          :class="{ hasError: this.loginError }"
          :value="login"
          @input="updateLogin"
          name="AuthForm[email]"
          placeholder="Логин"
          type="text"
          v-on:keydown.enter.prevent="submitAuth"
        />
        <small class="input-error" v-if="loginError">{{ loginError }}</small>
      </div>

      <div class="input-wrapper" v-if="authMethod == AUTH_METHOD_EMAIL">
        <input
          :class="{ hasError: this.passwordError }"
          :value="password"
          @input="updatePassword"
          name="AuthForm[password]"
          placeholder="Пароль"
          type="password"
          v-on:keydown.enter.prevent="submitAuth"
        />
        <small class="input-error" v-if="passwordError">{{
          passwordError
        }}</small>
      </div>

      <div class="input-wrapper" v-if="isSmsCodeValidation">
        <p
          class="input-info input-sms-message"
          v-html="smsCodeMessage"
          v-if="this.smsCodeMessage"
        ></p>
        <input
          :class="'input-sms ' + { hasError: this.smsCodeError }"
          :value="smsCode"
          @input="updateSmsCode"
          v-on:keydown.enter.prevent="submitSmsCode"
          name="RegistrationForm[code]"
          placeholder=""
          v-mask="'#####'"
          type="text"
          :disabled="this.isRequested"
        />

        <span class="input-error" v-if="this.smsCodeError">{{
          this.smsCodeError
        }}</span>
      </div>

      <div class="input-wrapper" v-if="this.authError">
        <p :key="error" class="input-error default-size">
          {{ this.authError }}
        </p>
      </div>

      <div class="input-wrapper" v-if="this.captchaError">
        <p class="input-error default-size">
          Ошибка прохождения Captcha. Пожалуйста, попробуйте авторизоваться еще
          раз
        </p>
      </div>

      <div v-if="isSmsCodeValidation" class="auth-form__footer">
        <input
          @click.prevent="submitSmsCode"
          class="basket-btn basket-btn_small button-center"
          type="submit"
          autofocus
          value="Отправить код"
        />
      </div>
      <div v-else class="auth-form__footer">
        <input
          @click="showRegistrationForm"
          class="basket-btn basket-btn_small"
          type="button"
          value="Зарегистрироваться"
        />
        <input
          @click.prevent="submitAuth"
          class="basket-btn basket-btn_small"
          type="submit"
          value="Войти"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { setting } from '@/setting';
import { mask } from 'vue-the-mask';
import { eventBus } from '../main';
import { mapState } from 'vuex';

export default {
  name: 'Login',
  directives: { mask },

  data() {
    const authPhone = 'phone';
    const authEmail = 'email';
    return {
      AUTH_METHOD_PHONE: authPhone,
      AUTH_METHOD_EMAIL: authEmail,
      authMethod: authEmail,
      authUrl: '',
      authHost: '',
      login: '',
      password: '',
      loginError: '',
      passwordError: '',
      authError: '',
      isSms: false,
      smsCode: '',
      isSmsCodeValidation: false,
      smsCodeMessage: 'На Ваш номер телефона отправлен код подтверждения',
      smsCodeError: '',
      isRequested: false,
      captchaError: false,
    };
  },

  computed: {
    ...mapState(['setting', 'theatre']),
  },

  created() {
    this.authUrl = setting.authHost + '/auth/async';

    eventBus.$on('signIn', (sender, login, password) => {
      this.signIn(sender, login, password);
    });
  },

  methods: {
    async submitSmsCode() {
      const smsCodeData = await this.$store.dispatch('sendSMSCode', {
        MobilePhone: this.login.replace(/\s|-|\(|\)/gi, ''),
        Code: this.smsCode,
        theatreId: this.$route.params.theatreId,
        setCookies: this.$cookie.set,
      });

      console.log(smsCodeData, 'smsCodeData');

      if (smsCodeData.success) {
        this.$modal.hide('modal-card');
      }

      if (smsCodeData.error) {
        this.authError = smsCodeData.error;
      }
    },

    async checkReCaptcha() {
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('login');
      const answer = await this.$store.dispatch('getStatusReCaptcha', {
        token,
      });
      return answer.Success;
    },

    async submitAuth(e) {
      this.captchaError = false;
      if (this.authMethod === this.AUTH_METHOD_PHONE) {
        if (!this.validateLogin()) return;

        if (!(await this.checkReCaptcha())) {
          this.captchaError = true;
          return;
        }

        let CrmSystemIdList = [];

        if (this.theatre.CrmSystemId)
          CrmSystemIdList = [this.theatre.CrmSystemId];

        const signInSmsPhoneData = await this.$store.dispatch(
          'signInSMSPhone',
          {
            MobilePhone: this.login.replace(/\s|-|\(|\)/gi, ''),
            CityId: this.theatre.CityId,
            CrmSystemIdList,
          },
        );

        console.log(signInSmsPhoneData, 'signInSmsPhoneData');
        this.isSmsCodeValidation = true;
        return true;
      } else {
        this.validateLogin();
        this.validatePassword();
        if (this.passwordError && this.loginError) {
          e.preventDefault();
        } else {
          let onError = function (sender, response) {
            if (response.errors) sender.authError = response.data.errors;
            else if (response.data && response.data.errors)
              sender.authError = response.data.errors;
            else sender.authError = 'Произошла непредвиденная ошибка';
          };

          await this.signIn(this, this.login, this.password, null, onError);
        }
      }
    },

    onAuthMethodChange(method /*, e*/) {
      this.authMethod = method;
      this.login = '';
    },

    updateLogin(e) {
      this.login = e.target.value;
      this.validateLogin();
    },

    updateSmsCode(e) {
      this.smsCode = e.target.value;
      this.validateSmsCode();
    },

    validateSmsCode() {
      if (this.isSmsCodeValidation) {
        if (!this.smsCode) {
          this.smsCodeError = 'Необходимо указать код из СМС';
          return false;
        }
      }
      this.smsCodeError = false;
      return true;
    },

    validateLogin() {
      if (!this.login) {
        this.loginError = 'Необходимо заполнить Логин';
        return false;
      }

      this.loginError = false;
      return true;
    },

    updatePassword(e) {
      this.password = e.target.value;
      this.validatePassword();
    },

    validatePassword() {
      if (!this.password) {
        this.passwordError = 'Необходимо заполнить пароль';

        return false;
      }

      this.passwordError = false;
      return true;
    },

    showRegistrationForm() {
      this.skip();
      this.$modal.show('registration-form');
    },

    skip() {
      this.$modal.hide('modal-card');
    },

    async signIn(sender, login, password) {
      if (!(await this.checkReCaptcha())) {
        this.captchaError = true;
        return;
      }

      const signInResult = await this.$store.dispatch('signIn', {
        Data: login,
        Password: password,
        theatreId: this.$route.params.theatreId,
        setCookies: this.$cookie.set,
        CrmSystemId: this.theatre.CrmSystemId,
      });

      if (signInResult.success) {
        this.$modal.hide('modal-card');
      } else {
        this.authError = signInResult.error;
        console.log(signInResult, signInResult.error);
      }
    },
  },
};
</script>

<style lang="scss">
.auth {
  &-form {
    position: relative;
    width: 35%;
    min-width: 450px;

    flex-direction: column;

    &__header {
      font-size: 20px;
      margin-top: 10px;
      margin-bottom: 20px;
      text-align: center;
      color: #ffffff;
    }

    &__footer {
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
    }
  }

  &.step-box {
    border: none;

    .input-wrapper {
      .input-sms {
        width: 100px;
        margin: 0 auto;
        display: block;
      }
    }

    .input-error {
      color: white !important;
      margin: 10px 0;
      font-size: 14px !important;

      a {
        color: white;
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }
}

.pz-close-btn-login {
  background: none;
  position: absolute;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  top: -20px;
  transform: scale(0.75);
  border: none;
  right: -20px;

  &:before {
    background: #fff;
    width: 24px;
    height: 2px;
    content: '';
    display: block;
    position: absolute;
    transform: rotate(-45deg);
  }

  &:after {
    background: #fff;
    width: 24px;
    height: 2px;
    content: '';
    display: block;
    position: absolute;
    transform: rotate(45deg);
  }

  &:hover {
    cursor: pointer;
  }
}

.pz-button-registration {
  background: none;
  border: none;
  color: white;
  margin: 10px 0;
  transition: all 0.3s ease;
}

.pz-button-registration:hover {
  opacity: 0.75;
}

.basket-btn {
  &_small {
    height: 45px;
    border: none;
    text-transform: none;
    border-radius: 8px;

    &.button-center {
      margin: 0 auto;
      width: 90%;
      position: relative;
      top: -10px;
    }

    &:focus {
      outline: none;
    }
  }
}

.basket-btn_alt_close {
  position: absolute;
  top: 15px !important;
  right: 15px !important;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  background: transparent;
  border: 1px solid #ccc;
  transform: rotate(45deg);
}

.basket-btn_alt_close::before,
.basket-btn_alt_close::after {
  position: absolute;
  left: 22px;
  content: ' ';
  height: 24px;
  width: 2px;
  background-color: #ccc;
  top: 10px;
}

.basket-btn_alt_close::before {
  transform: rotate(45deg);
}

.basket-btn_alt_close:hover {
  opacity: 1;
}

.signup-radio {
  &.signup-email,
  &.signup-phone {
    width: 50%;
    display: inline-block;
    margin: 0 0 10px 0;
  }
}

@media only screen and (max-width: 480px) {
  .auth {
    width: calc(100% - 30px);

    &-form {
      width: auto !important;
      min-width: auto !important;
    }

    .login-method {
      display: flex !important;
      flex-direction: column !important;
      width: 100% !important;

      label {
        width: 100% !important;
      }
    }
  }

  .auth-form__footer {
    flex-direction: column !important;
    margin-top: 0 !important;

    .basket-btn_close {
      margin-bottom: 15px !important;
    }
  }
}
</style>
